import { Component } from '@theme/component';

/**
 * @typedef {object} ProductAdditionalOptionsRefs
 * @property {HTMLInputElement} selectedAddonNames
 */

/**
 * Keeps selected add-on names synced to a hidden line-item property field.
 * @extends Component<ProductAdditionalOptionsRefs>
 */
class ProductAdditionalOptionsComponent extends Component {
  requiredRefs = ['selectedAddonNames'];

  connectedCallback() {
    super.connectedCallback();
    this.#syncSelectedNames();
  }

  handleSelectionChange() {
    this.#syncSelectedNames();
  }

  #syncSelectedNames() {
    const separator = this.dataset.propertySeparator || ', ';
    const checkedAddons = Array.from(
      this.querySelectorAll('input[name="addon_variant_id"]:checked')
    );

    const selectedNames = checkedAddons
      .map((input) => input.getAttribute('data-addon-name') || '')
      .filter((name) => name.trim() !== '');

    this.refs.selectedAddonNames.value = selectedNames.join(separator);
    this.refs.selectedAddonNames.disabled = selectedNames.length === 0;
  }
}

if (!customElements.get('product-additional-options-component')) {
  customElements.define('product-additional-options-component', ProductAdditionalOptionsComponent);
}
